import { GET_THEME_REQUESTED, GET_THEME_COMPLETED } from './types';

// import debug from '../../services/debug';

const getThemeAction = async () => async (dispatch) => {
  let localStorageThemeMode = true;
  if (localStorage.getItem('prefersDarkMode')) {
    localStorageThemeMode = false;
  }

  dispatch({
    type: GET_THEME_REQUESTED,
  });
  return dispatch({
    type: GET_THEME_COMPLETED,
    payload: localStorageThemeMode,
  });
};

export default getThemeAction;
